import React, {useEffect} from 'react';
import {setUpNewPlanContactIdField as shellPlanContactIdField} from './builderSetUpNewFields';
import AutoField, {SelectOption} from '../../../components/AutoForm/AutoFieldNew';
import {useAccountContext} from '../../../contexts/AccountContext';
import OWNERSHIP from '../../../constants/Ownership';
import {getContactName} from '../../../utils/getContactName';
import {useAutoField, AutoFieldHelpers} from '../../../components/AutoForm/useAutoForm';
import {AccountBasicFragment_contacts} from '../../../schema-types/AccountBasicFragment';
import {UPDATES} from '../../../shared/UPDATES';

export const setDefaultPlanContact = ({
  contacts,
  shellPlanContactHelpers,
}: {
  contacts: AccountBasicFragment_contacts[];
  shellPlanContactHelpers: AutoFieldHelpers<any>;
}) => {
  if (contacts.length === 1) {
    shellPlanContactHelpers.setValue(UPDATES._550, contacts[0].id);
  }
};

export const useSetDefaultPlanContact = (formikKeyPrefix: string) => {
  const [, , shellPlanContactHelpers] = useAutoField(`${formikKeyPrefix}.contactId`);
  const {account} = useAccountContext();
  const contacts = account?.contacts || [];
  useEffect(() => {
    setDefaultPlanContact({contacts, shellPlanContactHelpers});
  }, [contacts]);
};

export const BuilderPlanContactField: React.FC<{
  formikKeyPrefix: string;
  label?: string;
}> = ({formikKeyPrefix, label}) => {
  const [shellBuilderPlanContactField, shellPlanContactMeta, shellPlanContactHelpers] =
    useAutoField(`${formikKeyPrefix}.contactId`);
  const {accountId, account} = useAccountContext();
  const contacts = account?.contacts || [];
  useSetDefaultPlanContact(formikKeyPrefix);
  const contactOptions: SelectOption[] = contacts.map(
    (contact: AccountBasicFragment_contacts) => ({
      label: getContactName(contact),
      value: contact.id,
    })
  );
  if (contactOptions.length !== 1) {
    contactOptions.push({
      label: 'Joint',
      value: OWNERSHIP.JOINT_CODE,
    });
  }

  return (
    <AutoField
      field={{
        ...shellPlanContactIdField,
        label: label || shellPlanContactIdField.label,
        id: `${formikKeyPrefix}.contactId`,
        options: contactOptions || [],
        loading: !contacts.length,
      }}
    />
  );
};
